/* eslint-disable
    block-scoped-var,
   no-var,
    one-var,
    prefer-rest-params,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS103: Rewrite code to no longer use __guard__
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import React from 'react';
import _ from 'underscore';

import ReactDOM from 'react-dom';
import asm from 'assembly/Asm';
import StickyEndsAreaTemplate from 'assembly/StickyEndsAreaTemplate';
import StickyEndsRowTemplate from 'assembly/StickyEndsRowTemplate';
import AssemblyErrorsWarnings from 'assembly/views/AssemblyErrorsWarnings';
import * as util from 'biojs/Util';
import {DNA_COMPLEMENT_TABLE} from 'biojs/BioConstants';
import * as AssemblyConstants from 'constants/AssemblyConstants';

const {ASSEMBLY_TYPE} = AssemblyConstants;

import FileStates from 'FileStates';
import * as colors from 'lib/Colors';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import * as sequtil from 'molbio/SeqUtil';
import * as PrimerAssemblyTabView from './PrimerAssemblyTabView';

function stickyEndBases(sequence, upstreamFragment, downstreamFragment, start, end) {
  if (start != null && end != null) {
    return sequence.residueSlice(start, end);
  }
  if (upstreamFragment.has('end_sticky_end')) {
    return upstreamFragment.get('end_sticky_end');
  }
  if (downstreamFragment.has('start_sticky_end')) {
    return downstreamFragment.get('start_sticky_end');
  }
  return '';
}

class AssemblyCheckView extends Backbone.View {
  initialize({sequence}) {
    this.sequence = sequence;
  }

  checkAssembly() {
    let start, end;
    const _sequence = this.sequence._sequence();

    const stickyEndRanges = asm.goldenGate.stickyEndRanges(_sequence);
    let junctionStickyEnds = (() => {
      let downstreamFragment, upstreamFragment;
      const result = [];
      for ({upstreamFragment, downstreamFragment, start, end} of Array.from(stickyEndRanges)) {
        const upstreamName = __guard__(upstreamFragment.parent(), (x) => x.name);
        const downstreamName = __guard__(downstreamFragment.parent(), (x1) => x1.name);
        result.push(
          new asm.goldenGate.StickyEnd(
            stickyEndBases(this.sequence, upstreamFragment, downstreamFragment, start, end),
            `${upstreamName} / ${downstreamName}`
          )
        );
      }
      return result;
    })();
    // Remove empty strings (occurs if the sticky ends are not available).
    // eslint-disable-next-line no-restricted-syntax
    junctionStickyEnds = _.filter(junctionStickyEnds, (stickyEnd) => stickyEnd.bases.length > 0);

    // TODO(gg): should we cut the new sequence or the original fragments?
    const enzyme = _sequence.assembly().enzyme();
    const internalStickyEnds = _sequence.getCuts(enzyme.toJSON()).map((c) => {
      start = c.position;
      end = sequtil.mod(start + enzyme.get('offset'), _sequence.length());
      // Reverse start and end for negative offset.
      if (enzyme.get('offset') < 0) {
        [start, end] = Array.from([end, start]);
      }
      return new asm.goldenGate.StickyEnd(
        _sequence.residueSlice(start, end),
        `${_sequence.name()} at base ${start}`
      );
    });

    return asm.goldenGate.validateStickyEnds(junctionStickyEnds, internalStickyEnds, true);
  }

  render() {
    const {errors, warnings} = this.checkAssembly();
    renderToDOM(
      <AssemblyErrorsWarnings errors={errors} warnings={warnings} method={ASSEMBLY_TYPE.GOLDEN_GATE} />,
      this.el
    );
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

class StickyEndsRowView extends Backbone.View {
  static initClass() {
    this.prototype.template = StickyEndsRowTemplate;
    this.prototype.tagName = 'tr';
    this.prototype.events = {
      'click .js-upstream': function () {
        return this.open(this.upstreamFragment);
      },
      'click .js-downstream': function () {
        return this.open(this.downstreamFragment);
      },
    };
  }

  initialize({tabModel, upstreamFragment, downstreamFragment, bases}) {
    this.tabModel = tabModel;
    this.upstreamFragment = upstreamFragment;
    this.downstreamFragment = downstreamFragment;
    this.bases = bases;
  }

  open(fragmentResult) {
    if (fragmentResult.parent() == null) {
      return;
    }
    const sequenceID = fragmentResult.parent().id;
    FileStates.get().openFolderItem(sequenceID);
  }

  render() {
    const fragments = this.upstreamFragment.collection;
    const pastels = colors.shuffledPastelColors;
    this.$el.html(
      this.template({
        upstreamFragment: {
          name: __guard__(this.upstreamFragment.parent(), (x) => x.name) || 'deleted',
          color: this.tabModel.lighten(pastels[fragments.indexOf(this.upstreamFragment)]),
        },
        downstreamFragment: {
          name: __guard__(this.downstreamFragment.parent(), (x1) => x1.name) || 'deleted',
          color: this.tabModel.lighten(pastels[fragments.indexOf(this.downstreamFragment)]),
        },
        bases: this.bases,
        revcomp: util.revcomp(this.bases, DNA_COMPLEMENT_TABLE),
        showPrintableSummary: this.tabModel.showPrintableSummary(),
      })
    );
    return this;
  }
}
StickyEndsRowView.initClass();

class StickyEndsAreaView extends Backbone.View {
  static initClass() {
    this.prototype.template = StickyEndsAreaTemplate;
  }

  initialize({tabModel, sequence}) {
    this.tabModel = tabModel;
    this.sequence = sequence;
    this.listenTo(this.sequence._sequence(), 'change:bases change:fragmentResults', this.render);
    this.listenTo(this.sequence._sequence(), 'change:finalized', this.renderFinalizedMessage);
    this.stickyEndRows = [];
    this.assemblyCheckView = null;
  }

  renderFinalizedMessage() {
    const $finalizedMessageIcon = this.$('.js-finalized-message');
    $finalizedMessageIcon.popover('destroy');
    if (!this.sequence.finalized()) {
      $finalizedMessageIcon.addClass('hidden');
      return;
    }
    $finalizedMessageIcon.removeClass('hidden').popover({
      placement: 'bottom',
      content: 'The sticky end bases are from the sequence when it was finalized.',
      container: 'body',
      trigger: 'hover',
    });
  }

  render() {
    this.$el.html(this.template());
    this.renderFinalizedMessage();
    const stickyEndRanges = asm.goldenGate.stickyEndRanges(this.sequence._sequence());
    for (var row of Array.from(this.stickyEndRows)) {
      row.remove();
    }

    // eslint-disable-next-line no-restricted-syntax
    this.stickyEndRows = _.map(stickyEndRanges, ({upstreamFragment, downstreamFragment, start, end}) => {
      row = new StickyEndsRowView({
        tabModel: this.tabModel,
        upstreamFragment,
        downstreamFragment,
        bases: stickyEndBases(this.sequence, upstreamFragment, downstreamFragment, start, end),
      });
      this.$('.js-sticky-ends-tbody').append(row.render().el);
      return row;
    });

    if (this.assemblyCheckView != null) {
      this.assemblyCheckView.remove();
    }
    this.assemblyCheckView = new AssemblyCheckView({
      sequence: this.sequence,
      el: this.$('.assembly-check-mount')[0],
    });
    this.assemblyCheckView.render();
    return this;
  }

  remove() {
    for (const row of Array.from(this.stickyEndRows)) {
      row.remove();
    }
    if (this.assemblyCheckView != null) {
      this.assemblyCheckView.remove();
    }
    return super.remove();
  }
}
StickyEndsAreaView.initClass();

class GoldenGateTabOptionsView extends PrimerAssemblyTabView.OptionsView {}

class GoldenGateTabView extends PrimerAssemblyTabView.TabView {
  static initClass() {
    this.prototype.showBinding = false;
    this.prototype.showHomology = false;
  }

  initialize() {
    super.initialize(...arguments);
    this.stickyEndsView = null;
  }

  render() {
    super.render(...arguments);
    this.renderStickyEnds();
    return this;
  }

  renderStickyEnds() {
    const $area = this.$('.js-sticky-ends-area');
    $area.removeClass('hidden');
    if (this.stickyEndsView != null) {
      this.stickyEndsView.remove();
    }
    this.stickyEndsView = new StickyEndsAreaView({
      sequence: this.sequence,
      tabModel: this.model,
      el: $area[0],
    });
    this.stickyEndsView.render();
  }

  remove() {
    if (this.stickyEndsView != null) {
      this.stickyEndsView.remove();
    }
    return super.remove();
  }
}
GoldenGateTabView.initClass();

export {GoldenGateTabOptionsView as OptionsView, GoldenGateTabView as TabView};

function __guard__(value, transform) {
  return value != null ? transform(value) : undefined;
}
